// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Tags/TagsPicker/Content/mutation-delete-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm_Content_Content_Tags_TagsPicker_Content($id: uuid!) {
  delete_tasks_tags_by_pk(id: $id) {
    id
  }
}

`